import { NavbarType, TabType } from '../quickbase-types';
import { WarehousePresentation } from './host-bridge.messages';

export type QuickbaseSurface = NavbarType | TabType;

const DEFAULT_RECORD_PATH_SEGMENT = 'records';

const recordPathSegments: Partial<Record<QuickbaseSurface, string>> = {
	[NavbarType.Orders]: 'order-batches',
};

export function recordPathSegmentFor(surface: QuickbaseSurface): string {
	return recordPathSegments[surface] ?? DEFAULT_RECORD_PATH_SEGMENT;
}

const DEFAULT_RECORD_PRESENTATION: WarehousePresentation = 'modal';

const recordPresentations: Partial<Record<QuickbaseSurface, WarehousePresentation>> = {};

export function recordPresentationFor(surface: QuickbaseSurface): WarehousePresentation {
	return recordPresentations[surface] ?? DEFAULT_RECORD_PRESENTATION;
}

const recordPageNames: Partial<Record<QuickbaseSurface, string>> = {};

export function recordPageNameFor(surface: QuickbaseSurface): string | null {
	return recordPageNames[surface] ?? null;
}
